export default __webpack_public_path__ + "static/media/spacerace3.eeb8a6c7.png";